import { render, staticRenderFns } from "./outer.vue?vue&type=template&id=1ea77b6e&scoped=true&"
import script from "./outer.vue?vue&type=script&lang=js&"
export * from "./outer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea77b6e",
  null
  
)

export default component.exports